<template>
  <el-date-picker
    :type="dateType"
    :placeholder="placeholder"
    :value-format="dateFormat"
    :editable="editable"
    :clearable="clearable"
    v-model="dateModel"
    @change="setValue">
  </el-date-picker>
</template>

<script>
  export default {
    name: 'qunji-date',
    props: {
      type: {
        type: String,
        default: 'date'
      },
      placeholder: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      defaultValue: {
        type: String
      },
      editable: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        dateModel: this.defaultValue,
        dateType: '',
        dateFormat: ''
      }
    },
    created() {
      if (this.isEmpty(this.type)) {
        this.dateType = 'date'
      } else {
        this.dateType = this.type;
      }

      if (this.dateType === 'date') {
        this.dateFormat = 'yyyyMMdd'
      } else if (this.dateType === 'month') {
        this.dateFormat = 'yyyyMM'
      } else if (this.dateType === 'year') {
        this.dateFormat = 'yyyy'
      } else {
        this.dateFormat = 'yyyyMMdd'
      }

      console.log(this.dateFormat, this.dateType)
    },
    mounted() {
      if (this.isNotEmpty(this.dateModel)) {
        this.setValue(this.dateModel)
      }
      console.log(this.dateFormat, this.dateType)
    },
    watch: {
      defaultValue() {
        this.dateModel = this.defaultValue
        if (this.isNotEmpty(this.dateModel)) {
          this.setValue(this.dateModel)
        }
      }
    },
    methods: {
      setValue(val) {
        this.$emit('input', this.isEmpty(val) ? '' : val)
      }
    }
  }
</script>
